import { ContentFade, DefaultContentBox, MappedVehicleTypes, RegPlate, typographyRem } from '@by-miles/bymiles-styles'
import { DataLayer } from '@by-miles/data-layer'
import React from 'react'

import { useQuote } from '../../../../hooks/useQuote'
import { formatReg } from '../../../../utils/formatReg'
import { CarDetailsComponent } from '../../../CarDetailsComponent'
import { CarDetailsStyle } from './CarDetailsStyle'
const { captionLarge: CaptionLarge, labelLarge: LabelLarge, paragraphBody: ParagraphBody } = typographyRem

interface CarDetailsProps {
  onClick: () => void
}

export const CarDetails = ({ onClick }: CarDetailsProps) => {
  const quote = useQuote()

  const sanitizeCarModel = (make: string, model: string, trim: string) => {
    if (!make && !model && !trim) return ''
    if (model === 'MINI' && trim) return trim
    if (make === 'DS') return model.replace('DS ', '')
    return model
  }

  const handleNotMyCar = () => {
    onClick()
    DataLayer.customEvent({
      eventName: 'changes car',
      section: 'car',
      eventType: 'form tracking',
    })
  }

  return (
    <CarDetailsStyle>
      <DefaultContentBox data-cy="car-info-container" className="car-details-box">
        <div className="car-view">
          <div className="car-view-section">
            <div className="reg-wrapper">
              <div className="image-wrapper">{MappedVehicleTypes(quote?.details?.vehicle?.type || '')}</div>
              <div className="car-reg is-mobile">
                <RegPlate>{formatReg(quote?.details?.vehicle?.reg)}</RegPlate>
              </div>
            </div>
          </div>
          <div className="car-view-section">
            <LabelLarge className="car-name">
              {quote?.details?.vehicle?.make}{' '}
              {sanitizeCarModel(
                quote?.details?.vehicle?.make || '',
                quote?.details?.vehicle?.model || '',
                quote?.details?.vehicle?.trim || '',
              )}
            </LabelLarge>
          </div>
          <div className="car-view-section">
            <CaptionLarge>{quote?.details?.vehicle?.type}</CaptionLarge>
          </div>
          <div className="car-view-section car-reg is-tablet">
            <RegPlate>{formatReg(quote?.details?.vehicle?.reg || '')}</RegPlate>
          </div>
          <div className="car-view-section">
            <ParagraphBody onClick={handleNotMyCar} className="not-my-car" data-cy="incorrect-car-button">
              This is not my car
            </ParagraphBody>
          </div>
        </div>
        <div className="is-mobile">
          <ContentFade expandLabel="See car details">
            <CarDetailsComponent className="car-details-container" />
          </ContentFade>
        </div>

        <CarDetailsComponent className="car-details-container is-tablet" />
      </DefaultContentBox>
    </CarDetailsStyle>
  )
}
